var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCyber(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.3672 35.3719C58.522 35.3719 65.1328 28.7612 65.1328 20.6063C65.1328 12.4515 58.522 5.8407 50.3672 5.8407C42.2124 5.8407 35.6016 12.4515 35.6016 20.6063C35.6016 28.7612 42.2124 35.3719 50.3672 35.3719Z",
    fill: "#DDE2E4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4157 14.1531H55.5845C56.4721 14.1531 57.3234 14.5057 57.9511 15.1334C58.5787 15.761 58.9313 16.6123 58.9313 17.5V49.2187H11.0688V17.5C11.0688 16.6123 11.4215 15.761 12.0491 15.1334C12.6768 14.5057 13.5281 14.1531 14.4157 14.1531V14.1531Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.497 59.8172H7.50325C7.23789 59.8183 6.97597 59.7572 6.73856 59.6387C6.50115 59.5201 6.29488 59.3475 6.13634 59.1347C5.97781 58.9219 5.87144 58.6749 5.8258 58.4135C5.78016 58.1521 5.79652 57.8836 5.87356 57.6297L11.0689 49.2188H58.9314L64.1267 57.6625C64.1976 57.9144 64.2092 58.1792 64.1607 58.4363C64.1122 58.6935 64.0048 58.9359 63.8469 59.1445C63.6891 59.3532 63.4851 59.5226 63.2509 59.6393C63.0167 59.7559 62.7587 59.8168 62.497 59.8172V59.8172Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1187 19.7532H58.3077",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3452 54.1078H55.1468",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1907 32.7358H53.1126",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1907 28.022H50.2032",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0969 43.5421C31.1106 43.5421 35.175 39.4777 35.175 34.464C35.175 29.4503 31.1106 25.3859 26.0969 25.3859C21.0832 25.3859 17.0188 29.4503 17.0188 34.464C17.0188 39.4777 21.0832 43.5421 26.0969 43.5421Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M26.097 34.7593C27.5709 34.7593 28.7657 33.5644 28.7657 32.0905C28.7657 30.6166 27.5709 29.4218 26.097 29.4218C24.6231 29.4218 23.4282 30.6166 23.4282 32.0905C23.4282 33.5644 24.6231 34.7593 26.097 34.7593Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4937 41.8031V40.4688C30.4937 39.3084 30.0327 38.1956 29.2122 37.3752C28.3918 36.5547 27.279 36.0938 26.1187 36.0938",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0969 36.0938C24.9366 36.0938 23.8238 36.5547 23.0033 37.3752C22.1829 38.1956 21.7219 39.3084 21.7219 40.4688V42.2953",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1126 37.1108H41.1907V42.1093H53.1126V37.1108Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCyber);
export default __webpack_public_path__ + "static/media/cyber.3b816ea0335642d9bcb2892a6862efa2.svg";
export { ForwardRef as ReactComponent };